export const LIVE = 'LIVE';
export const FINISHED = 'FINISHED';
export const NOT_STARTED = 'NOT_STARTED';
export const INTERRUPTED = 'INTERRUPTED';
export const CANCELLED = 'CANCELLED';
export const NOT_LIVE = 'NOT_LIVE';
export const UNKNOWN = 'UNKNOWN';
export const ABANDONED = 'ABANDONED';
export const POSTPONED = 'POSTPONED';
export const FINISHED_AFTER_PENALTIES = 'finished_ap';
export const FINISHED_AFTER_EXTRA_TIME = 'finished_aet';
export const IN_PROGRESS = 'inprogress';
